import React, { useState, useEffect } from 'react';
import { FaOpenid, FaBars } from 'react-icons/fa';
import { AiOutlineDown } from 'react-icons/ai';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

function Nav() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [resourcesDropdownOpen, setResourcesDropdownOpen] = useState(false);
  const [mediaDropdownOpen, setMediaDropdownOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);  // State for "Services" dropdown

  const handleSignUp = () => {
    const redirectUri =
      window.location.origin === "http://localhost:3000"
        ? "http://localhost:3000/dashboard"
        : "https://www.pressrequest.io/dashboard";

    loginWithRedirect({
      redirectUri,
      authorizationParams: {
        screen_hint: "signup",
      },
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto">
      <nav className="flex items-center justify-between bg-white p-4 sm:p-6 relative">
        {/* Left Section: Logo */}
        <div onClick={() => navigate("/")} className="flex items-center flex-shrink-0 text-black mr-4 cursor-pointer">
          <FaOpenid className="mr-2 text-black" />
          <a className="font-semibold text-lg sm:text-xl tracking-tight">PressRequest</a>
        </div>

        {/* Mobile Hamburger Icon */}
        <div className="lg:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-black focus:outline-none">
            <FaBars className="text-xl" />
          </button>
        </div>

        {/* Center Section: Dropdowns (visible only on md and up) */}
        <div className="hidden lg:flex justify-center flex-grow relative space-x-4">
          {/* Resources Dropdown */}
          {/* <div className="relative">
            <button
              type="button"
              className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium rounded-lg text-sm px-5 py-2 flex items-center"
              onClick={() => { setResourcesDropdownOpen(!resourcesDropdownOpen); setMediaDropdownOpen(false); setServicesDropdownOpen(false); }}
            >
              Resources
              <AiOutlineDown className="ml-2 text-lg md:text-sm" />
            </button>
            {resourcesDropdownOpen && (
              <div className="absolute left-0 top-full mt-2 bg-white shadow-lg rounded-lg w-48 z-10">
                <a href="/blog" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setResourcesDropdownOpen(false)}>Blog</a>
              </div>
            )}
          </div> */}

          {/* For Media Dropdown */}
          <div className="relative">
            <button
              type="button"
              className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium rounded-lg text-sm px-5 py-2 flex items-center"
              onClick={() => { setMediaDropdownOpen(!mediaDropdownOpen); setResourcesDropdownOpen(false); setServicesDropdownOpen(false); }}
            >
              For Media
              <AiOutlineDown className="ml-2 text-lg md:text-sm" />
            </button>
            {mediaDropdownOpen && (
              <div className="absolute left-0 top-full mt-2 bg-white shadow-lg rounded-lg w-48 z-10">
                <a href="/query" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setMediaDropdownOpen(false)}>Submit Your Query</a>
              </div>
            )}
          </div>

          {/* Services Dropdown */}
          <div className="relative">
            <button
              type="button"
              className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium rounded-lg text-sm px-5 py-2 flex items-center"
              onClick={() => { setServicesDropdownOpen(!servicesDropdownOpen); setResourcesDropdownOpen(false); setMediaDropdownOpen(false); }}
            >
              Services
              <AiOutlineDown className="ml-2 text-lg md:text-sm" />
            </button>
            {servicesDropdownOpen && (
              <div className="absolute left-0 top-full mt-2 bg-white shadow-lg rounded-lg w-48 z-10">
                <a href="/pr-as-a-service" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setServicesDropdownOpen(false)}>Our Services</a>
                {/* Add more services links here if needed */}
              </div>
            )}
          </div>
        </div>

        {/* Right Section: Sign In / Sign Up */}
        <div className="ml-auto hidden lg:flex space-x-4">
          <button
            type="button"
            className="text-black sm:text-sm text-xs sm:px-4 px-2 py-2"
            onClick={() => loginWithRedirect()}
          >
            Sign In
          </button>
          <button
            type="button"
            className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"
            onClick={handleSignUp}
          >
            Sign Up
          </button>
        </div>

        {/* Mobile Menu: Toggle visibility when `menuOpen` is true */}
        {menuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg rounded-lg w-full z-10 lg:hidden">
            <button className="block w-full text-black text-sm px-4 py-2 text-left hover:bg-gray-200" onClick={() => loginWithRedirect()}>Sign In</button>
            <button className="block w-full text-black text-sm px-4 py-2 text-left hover:bg-gray-200" onClick={handleSignUp}>Sign Up</button>

            {/* Resources, For Media, and Services - Indented in mobile view */}
            {/* <div className="relative">
              <button
                type="button"
                className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium text-sm px-5 py-2 flex items-center w-full text-left"
                onClick={() => { setResourcesDropdownOpen(!resourcesDropdownOpen); setMediaDropdownOpen(false); setServicesDropdownOpen(false); }}
              >
                Resources
              </button>
              {resourcesDropdownOpen && (
                <div className="pl-6 bg-white shadow-lg w-full">
                  <a href="/blog" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setResourcesDropdownOpen(false)}>Blog</a>
                </div>
              )}
            </div> */}

            <div className="relative">
              <button
                type="button"
                className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium text-sm px-5 py-2 flex items-center w-full text-left"
                onClick={() => { setMediaDropdownOpen(!mediaDropdownOpen); setResourcesDropdownOpen(false); setServicesDropdownOpen(false); }}
              >
                For Media
              </button>
              {mediaDropdownOpen && (
                <div className="pl-6 bg-white shadow-lg w-full">
                  <a href="/query" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setMediaDropdownOpen(false)}>Submit Your Query</a>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                type="button"
                className="text-black bg-white hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-white-300 font-medium text-sm px-5 py-2 flex items-center w-full text-left"
                onClick={() => { setServicesDropdownOpen(!servicesDropdownOpen); setResourcesDropdownOpen(false); setMediaDropdownOpen(false); }}
              >
                Services
              </button>
              {servicesDropdownOpen && (
                <div className="pl-6 bg-white shadow-lg w-full">
                  <Link to="/pr-as-a-service" className="block px-4 py-2 text-black text-sm font-medium hover:bg-gray-200" onClick={() => setServicesDropdownOpen(false)}>
                    Our Services
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
}

export default Nav;
